var exports = {
  "qS": "SettingsStatusBadge.module__badge___bEQyd3",
  "Hl": "SettingsStatusBadge.module__new___bEQyd3",
  "ny": "SettingsStatusBadge.module__experimental___bEQyd3",
  "jp": "SettingsStatusBadge.module__badges___bEQyd3",
};

module.exports = exports;
